module.exports = __webpack_public_path__ + "static/media/bg_mobile.ba816664.svg";